export default "__VITE_ASSET__G$vm6YcS__"